
        <video #video [src]="videoSrc" [style.visibility]="hidden ? 'hidden' : 'visible'" (ended)="onEnded()" (canplay)="onCanplay()">
        </video>
    